export default function Poems() {
	return <h1 className="color-white mt-3">Poems</h1>;
}
